




































































import { Component, Vue, Prop, Inject, Ref } from 'vue-property-decorator';
import Order from '../Order/Order.vue';
import CustomerNewButton from '@/components/Customer/CustomerNewButton.vue';
import {
  populateOrderWithUserNonChangeableCustomerInfo,
  populateOrderWithUserChangeableCustomerInfo,
} from '@/app/Order';
import Bugsnag from '@bugsnag/js';
import UnitClosingDatesInfo from '@/components/Unit/UnitClosingDatesInfo.vue';
import { GQL_orderCustomerSearch_customers } from '@/queries/__generated__/orderCustomerSearch';
import { GQL_createCustomer_createCustomer_customer } from '@/queries/__generated__/createCustomer';
import SApolloAutocomplete from '@/components/UI/Form/Autocomplete/SApolloAutocomplete.vue';
import gql from 'graphql-tag';

const ORDER_CUSTOMER_SEARCH = gql`
  query orderCustomerSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: CustomerFilter
  ) {
    customers(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ){
      id
      unit {
        id
        name
        address
        zip
        city
        country {
          code
          name
        }
        mobile
        openedDate
        closedDate
        vatRegulation
        foretaksRegisteredSince
        highestPriorityIdentity {
          id
          value
          identificator {
            id
            name
          }
        }
      }
      phone
      email
      unofficialName
      customerContacts {
        id
        firstName
        lastName
      }
      deliveryLocations {
        id
        address
        additionalAddress
        city
        zip
        country {
          code
          name
        }
      }
      reference
    }
  }
`;

@Component({
  components: {
    CustomerNewButton,
    UnitClosingDatesInfo,
  },
})
export default class CustomerInfo extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public document!: any;
  @Prop({ type: String, default: 'full' }) public mode!: 'full' | 'minimal';
  @Inject() public documentComponent!: Order;
  @Inject() public documentType!: 'order' | 'invoice';

  @Ref() private customerAutocomplete?: SApolloAutocomplete<unknown>;

  get editable() {
    return this.documentType === 'order' && this.documentComponent.reactiveProps.editable;
  }

  private ORDER_CUSTOMER_SEARCH = ORDER_CUSTOMER_SEARCH

  public setCustomer(customer: GQL_orderCustomerSearch_customers) {
    if (!customer.id) return;

    populateOrderWithUserNonChangeableCustomerInfo(this.document, customer);
    populateOrderWithUserChangeableCustomerInfo(this.document, customer);
    Bugsnag.leaveBreadcrumb('Customer set', { customer });
  }

  public setNewlyCreatedCustomer(customer: GQL_createCustomer_createCustomer_customer) {
    if (!customer.id) return;

    // We have to refresh keepAliveItem so that SApolloAutocomplete
    // can display, and select the option.
    this.customerAutocomplete?.autocompleteRef?.setKeepAliveItem(customer);
    this.customerAutocomplete?.autocompleteRef?.selectOption(customer);
  }

  public unsetCustomer() {
    this.document.customer = { id: null };
    this.document.customerParty.name = null;
    this.document.customerParty.unofficialName = null;
    this.document.customerParty.streetName = null;
    this.document.customerParty.zip = null;
    this.document.customerParty.city = null;
    this.document.customerParty.phone = null;
    this.document.customerParty.mobile = null;
    this.document.customerParty.email = null;

    this.document.customerParty.partyIdentificationScheme = null;
    this.document.customerParty.partyIdentification = null;

    this.document.customerParty.country = { id: null };
    this.document.customerParty.countryCode = null;
    this.document.customerParty.reference = null;

    this.document.orderDelivery = {
      date: this.document.orderDelivery.date,
      streetName: null,
      additionalStreetName: null,
      city: null,
      zip: null,
      country: { id: null },
      countryCode: null,
    };
    Bugsnag.leaveBreadcrumb('Customer unset');
  }
}
